import { FButton } from "ferrum-design-system";
import { WalletConnector } from "foundry";
import { ConnectWalletDialogMultiSwap } from "../../../utils/connect-wallet/ConnectWalletDialogMultiSwap";
import { WalletConnectorButtonInterface } from "../interfaces/WalletConnectorButtonInterface";

export const ConnectButton = ({
  title,
  className,
}: WalletConnectorButtonInterface) => {
  return (
    <WalletConnector
      WalletConnectView={FButton}
      WalletConnectModal={ConnectWalletDialogMultiSwap}
      WalletConnectViewProps={{
        title: title,
        className: className,
      }}
    />
  );
};
